import connectManagerClient from '@/lib/connect-client/connect-manager-client'
import connectNaviClient from '@/lib/connect-client/connect-navi-client'
import connectDatastoreClient from '@/lib/connect-client/connect-datastore-client'
import * as Constants from '@/lib/constants'
import DevicesInfo from '@/lib/devices-info'
import Geo from '@/lib/geo'
import NaviRealtimeInfo from '@/lib/navi-realtime-info'
import UserInfo from '@/lib/user-info'
import UTCDateTime from '@/lib/utc-datetime'
import WebMarkersInfo from '@/lib/web-markers-info'

const turf = require('@turf/turf')

// Arrowマーカー（実験実装）
const USE_ARROW_MARKER = true

export default {
  computed: {
    realtimeActiveDeviceIds() {
      return this.$store.getters.realtimeActiveDeviceIds
    },
  },

  watch: {
    realtimeActiveDeviceIds: function(newVal, oldVal) {
      this.updateAllDevices()
    },
    activeTractorExists: function(newVal, oldVal) {
      // TODO
      // Toast.error('トラクターが稼働してません', { x: 'center', y: 'bottom' })
      // Toast.success('トラクターが稼働しています', { x: 'center', y: 'bottom' })
    },
  },

  data() {
    return {
      awsIot: require('aws-iot-device-sdk'),
      mqtt: undefined,

      store: this.$store,
      activeTractorExists: false,

      allDevices: [], // {device: device, info: realtimeInfo, monitor: boolean}
      latestTracks: {}, // {"username+deviceId": {"trackKey": trackKey, "geoJson": geoJson}}

      naviRealtimeInfo: undefined,

      arrowUpdateId: undefined,

      jumpedFirstTime: false,

      nowGeoJsons: { type: 'FeatureCollection', features: [] },

      nowMarkers: [],
      googleMapArrowsColor: {}, // MarkerArrow

      fieldFillColor: Constants.FIELD_FILL_COLOR,
      fieldOpacity: Constants.FIELD_FILL_OPACITY,
    }
  },

  methods: {
    getArrowUpdateId() {
      return this.arrowUpdateId
    },

    resetArrowUpdateTargetDevice() {
      this.arrowUpdateId = undefined
      this.currentWebMarkerDevice = undefined
    },

    updateWebMarker(device, trackColor, trackName) {
      const repaint = this.repaint
      this.$store.dispatch('updateWebMarker', { device, trackColor, trackName, callback: repaint })
    },

    repaint() {
      this.repaintArrow(this.currentWebMarkerDevice)
    },

    repaintArrow(device) {
      const identifier = DevicesInfo.getIdentifier(device.username, device.id)

      const arrowColor = WebMarkersInfo.getTrackColor(device.username, device.id)
      this.googleMapArrowsColor[identifier] = arrowColor
      this.arrowUpdateId = this.getMapArrowSymbolImageId(identifier)
    },

    initDeviceMarkers() {
      const devices = DevicesInfo.devices()
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i]
        const identifier = DevicesInfo.getIdentifier(device.username, device.id)

        // MarkerArrowを生成
        const arrowColor = WebMarkersInfo.getTrackColor(device.username, device.id)

        this.googleMapArrowsColor[identifier] = arrowColor
      }
    },

    updateAllDevices() {
      const devices = DevicesInfo.devices()
      const infos = this.$store.getters.realtimeDeviceInfos
      this.allDevices = []
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i]
        const identifier = DevicesInfo.getIdentifier(device.username, device.id)
        const info = infos[identifier]
        const deviceInfo = { device, info, monitor: true }
        this.allDevices.push(deviceInfo)
      }
      if (this.realtimeActiveDeviceIds.length === 0) {
        this.activeTractorExists = false
      } else {
        this.activeTractorExists = true
      }
    },

    onDeviceMonitorChanged(device, event) {
      const identifier = DevicesInfo.getIdentifier(device.username, device.id)
      //eventはboolean
      let googlemap = this.$refs.googleMapRef

      if (event === false) {
        googlemap.$mapPromise.then(map => {
          map.data.forEach(feature => {
            const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)
            if (type !== Constants.GeoFeaturePropertiesType.FIELD) {
              if (type === identifier) {
                map.data.remove(feature)
              }
            }
          })
        })
      }
      this.nowMarkers.forEach(marker => {
        if (marker.label === this.getMapArrowSymbolImageId(identifier)) {
          marker.visible = event
        }
      })
    },

    connectMqtt() {
      const awsSession = this.$store.getters.awsSession
      const store = this.$store

      if (awsSession) {
        const awsAccessKeyId = awsSession.accessKeyId
        const secretAccessKey = awsSession.secretAccessKey
        const awsSessionToken = awsSession.sessionToken
        let iotEndPoint = awsSession.iotEndPoint
        // iotEndPoint = 'a3rogeunimfujz-ats.iot.us-west-2.amazonaws.com' // FIXME
        // iotEndPoint = 'a3rogeunimfujz-ats.iot.eu-central-1.amazonaws.com' // FIXME
        // iotEndPoint = 'a3rogeunimfujz-ats.iot.sa-east-1.amazonaws.com' // FIXME

        if (!this.mqtt || !this.mqtt.connected) {
          this.mqtt = this.awsIot.device({
            protocol: 'wss',
            accessKeyId: awsAccessKeyId,
            secretKey: secretAccessKey,
            sessionToken: awsSessionToken,
            host: iotEndPoint,
            clientId: 'connect-web_' + UserInfo.getUsername() + '_' + Date.now(),
          })
        }
        // autoResubscribe=trueだから
        // https://github.com/aws/aws-iot-device-sdk-js#awsiotdeviceoptions
        if (!this.mqtt.connected) {
          this.mqtt.on('connect', () => {
            const topicNames = this.getTopicNames()
            for (let i = 0; i < topicNames.length; i++) {
              const topicName = topicNames[i]
              this.mqtt.subscribe(topicName)
// TEMP               console.log('Connected to MQTT: topic=' + topicName, 'endpoint=' + iotEndPoint)
            }
          })

          const eventBus = this.realTimeEventBus
          // メッセージ受信
          this.mqtt.on('message', (topic, message) => {
// TEMP             console.debug('Received from MQTT: topic=' + topic + 'message: ' + message.toString())
            const naviRealtimeInfo = new NaviRealtimeInfo(message.toString())
            store.dispatch('addRealtimeInfo', naviRealtimeInfo)
            eventBus.$emit(Constants.EVENT_SHOW_REALTIME_POINT, naviRealtimeInfo)
            eventBus.$emit(Constants.EVENT_SHOW_LATEST_TRACK, naviRealtimeInfo)
          })

          this.mqtt.on('reconnect', () => {
// TEMP             console.log('Reconnect MQTT')

            // FIXME
            // AccessTokenをリフレッシュすることにより、awsSessionTokenをリフレッシュする
            connectManagerClient.refreshAccessToken().then(response => {
              store.dispatch('refreshTokenSuccess', response.data)
            })
            if (awsSession) {
              const awsAccessKeyId = awsSession.accessKeyId
              const secretAccessKey = awsSession.secretAccessKey
              const awsSessionToken = awsSession.sessionToken
              const sessionExpiredAtUTCString = awsSession.sessionExpiredAt
              if (sessionExpiredAtUTCString) {
                const expiration = UTCDateTime.toUtcMoment(sessionExpiredAtUTCString).toDate()
                this.mqtt.updateWebSocketCredentials(awsAccessKeyId, secretAccessKey, awsSessionToken, expiration)
              }
            }
          })
        }
      }
    },

    getMyTopicName() {
      const topicName = Constants.MQTT_TOPIC_PATH_PREFIX + UserInfo.getUsername() + '/#'
      return topicName
    },

    getTopicNames() {
      let topics = [this.getMyTopicName()] // まずは自分のtopicName
      const store = this.$store
      const subscribingAccounts = store.getters.subscribingAccounts
      if (subscribingAccounts) {
        for (let i = 0; i < subscribingAccounts.length; i++) {
          let topic = Constants.MQTT_TOPIC_PATH_PREFIX + subscribingAccounts[i].uuid + '/#'
          topics.push(topic)
        }
      }
      return topics
    },

    isActive(device) {
      const identifier = DevicesInfo.getIdentifier(device.username, device.id)
      return this.$store.getters.realtimeActiveDeviceIds.includes(identifier)
    },
    getMapArrowSymbolImageId(identifier) {
      return 'arrowSymbolImage-' + identifier
    },
    getMapChocottoSourceId(username, deviceId) {
      return 'chocottoSource-' + username + '-' + deviceId
    },
    getMapChocottoLayerId(username, deviceId) {
      return 'chocottoLayer-' + username + '-' + deviceId
    },

    setNaviRealtimeInfo: function(naviRealtimeInfo) {
      this.naviRealtimeInfo = naviRealtimeInfo
    },

    setUpShowRealtimeEventHandler(realTimeEventBus, store) {
      const googlemap = this.$refs.googleMapRef

      const getMapArrowSymbolImageId = this.getMapArrowSymbolImageId

      const setNaviRealtimeInfo = this.setNaviRealtimeInfo

      const getArrowUpdateId = this.getArrowUpdateId
      const resetArrowUpdateTargetDevice = this.resetArrowUpdateTargetDevice

      const allDevices = this.allDevices
      const isActive = this.isActive

      let nowMarkers = this.nowMarkers

      let movedFirstTime = this.jumpedFirstTime

      const fillColor = this.fieldFillColor
      const fillOpacity = this.fieldOpacity

      // MQTTでメッセージを受け取った時のイベントハンドラ
      realTimeEventBus.$on(Constants.EVENT_SHOW_REALTIME_POINT, function(naviRealtimeInfo) {
        let jumped = false

        const deviceId = naviRealtimeInfo.getDeviceId()
        const username = naviRealtimeInfo.getUsername()

        const identifier = DevicesInfo.getIdentifier(username, deviceId)
        setNaviRealtimeInfo(naviRealtimeInfo)
        const center = new google.maps.LatLng(
          store.getters.realtimeMapCenterPosition[1],
          store.getters.realtimeMapCenterPosition[0]
        )

        // activeだけども表示は全てオフの場合、jumpTo/flyToしないようにする
        let displayCount = 0

        for (let i = 0; i < allDevices.length; i++) {
          // {device: device, info: realtimeInfo, monitor: boolean}
          const active = isActive(allDevices[i].device)
          const monitor = allDevices[i].monitor
          if (active) {
            if (monitor) {
              ++displayCount
            }
          }
        }
        if (displayCount !== 0) {
          if (!jumped) {
            // 初回のjumpは行う
            if (!movedFirstTime) {
              movedFirstTime = true
              googlemap.$mapPromise.then(map => {
                let bounds = new google.maps.LatLngBounds()
                bounds.extend(center)
                map.fitBounds(bounds)
              })
              jumped = true
            }
          }
        }

        let idDrawPolygon = true
        nowMarkers.forEach(marker => {
          if (marker.label === getMapArrowSymbolImageId(identifier)) {
            idDrawPolygon = marker.visible
          }
        })

        if (idDrawPolygon) {
          const points = store.getters.realtimePositions[identifier]
          const polygons = store.getters.realtimePolygon[identifier]

          const lat = points[points.length - 1][0]
          const lng = points[points.length - 1][1]
          const rotate = naviRealtimeInfo.getRotation()

          if (points.length > 1) {
            const multiPolygonGeoJson = turf.multiPolygon(polygons)

            multiPolygonGeoJson.properties.type = identifier
            multiPolygonGeoJson.properties.color = WebMarkersInfo.getTrackColor(username, deviceId)
            this.nowGeoJsons = { type: 'FeatureCollection', features: [] }

            this.nowGeoJsons.features.push(multiPolygonGeoJson)

            googlemap.$mapPromise.then(map => {
              map.data.forEach(feature => {
                const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)
                if (type !== Constants.GeoFeaturePropertiesType.FIELD) {
                  if (type === identifier) {
                    map.data.remove(feature)
                  }
                }
              })

              map.data.addGeoJson(this.nowGeoJsons)
              const tracking = store.getters.realtimeAutoTracking
              if (tracking) {
                map.setCenter(center)
              }
              map.data.setStyle(feature => {
                const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)
                if (type === Constants.GeoFeaturePropertiesType.FIELD) {
                  return {
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                    strokeColor: Constants.FIELD_FILL_COLOR,
                    strokeWeight: 1,
                    zIndex: 0,
                  }
                } else {
                  const color = feature.getProperty('color')
                  return {
                    fillColor: color,
                    fillOpacity: Constants.NOW_TRACK_OPACITY,

                    strokeWeight: 0,
                    strokeOpacity: 0,
                    zIndex: 1,
                  }
                }
              })

              let isNotFoundMarker = true

              nowMarkers.forEach(marker => {
                if (marker.label === getMapArrowSymbolImageId(identifier)) {
                  marker.position = new google.maps.LatLng(lng, lat)
                  isNotFoundMarker = false
                  marker.icon = {
                    fillColor: WebMarkersInfo.getTrackColor(username, deviceId),
                    fillOpacity: 1,
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    strokeColor: WebMarkersInfo.getTrackColor(username, deviceId),
                    scale: 5,
                    rotation: rotate,
                  }
                }
              })

              if (isNotFoundMarker) {
                const marker = {
                  label: getMapArrowSymbolImageId(identifier),
                  visible: true,
                  position: new google.maps.LatLng(lng, lat),
                  icon: {
                    fillColor: WebMarkersInfo.getTrackColor(username, deviceId),
                    fillOpacity: 1,
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    strokeColor: WebMarkersInfo.getTrackColor(username, deviceId),
                    scale: 5,
                    rotation: rotate,
                  },
                }
                nowMarkers.push(marker)
              }
            })
          }
        }
      })
    },

    setUpShowLatestTrackEventHandler(realTimeEventBus, store) {
      let latestTracks = this.latestTracks
      const googlemap = this.$refs.googleMapRef

      const fillColor = this.fieldFillColor
      const fillOpacity = this.fieldOpacity

      const selfThis = this

      realTimeEventBus.$on(Constants.EVENT_SHOW_LATEST_TRACK, function(naviRealtimeInfo) {
        const username = naviRealtimeInfo.getUsername()
        const deviceId = naviRealtimeInfo.getDeviceId()
        const trackKey = naviRealtimeInfo.getTrackKey()

        const id = username + '-' + deviceId

        const params = {
          latestTracks: latestTracks,
          googlemap: googlemap,
          fillColor: fillColor,
          fillOpacity: fillOpacity,
          username: username,
          deviceId: deviceId,
          trackKey: trackKey,
          id: id,
        }

        let trackInfo = latestTracks[id]

        if (!trackInfo) {
          // APIのレスがあるまで動き続けるので先にセットする
          latestTracks[id] = { trackKey: trackKey }
          if (UserInfo.isFSMigrated()) {
            connectDatastoreClient
              .getRealtimeInfos(username, deviceId, trackKey)
              .then(response => {
                selfThis.afterGetRealtimeInfos(params, response)
              })
              .catch(error => {
                console.error(error)
              })
          } else {
            connectNaviClient
              .getRealtimeInfos(username, deviceId, trackKey)
              .then(response => {
                selfThis.afterGetRealtimeInfos(params, response)
              })
              .catch(error => {
                console.error(error)
              })
          }
        }
      })
    },
    afterGetRealtimeInfos(params, response) {
      let latestTracks = params.latestTracks
      const googlemap = params.googlemap
      const fillColor = params.fillColor
      const fillOpacity = params.fillOpacity
      const username = params.username
      const deviceId = params.deviceId
      const trackKey = params.trackKey
      const id = username + '-' + deviceId

      const geoJson = response.data
      latestTracks[id] = { trackKey: trackKey, geoJson: geoJson }
      const points = turf.coordAll(geoJson)
      let polygons = []
      // ポイントが2点以上の場合のみ
      if (points.length > 2) {
        for (let i = 1; i < points.length; i++) {
          let twoAgoPoint = null
          if (i > 1) {
            twoAgoPoint = points[i - 2]
          }
          const coords = Geo.pointToPolygonCoords(
            points[i - 1],
            points[i],
            Constants.DEFAULT_WORK_WIDTH, // 作業幅を持っていないのでデフォルトの5をセット
            Constants.DEFAULT_WORK_WIDTH, // 作業幅を持っていないのでデフォルトの5をセット
            twoAgoPoint
          )

          polygons.push(coords)
        }
        const multiPolygonGeoJson = turf.multiPolygon(polygons)
        multiPolygonGeoJson.properties.color = WebMarkersInfo.getTrackColor(username, deviceId)
        let chocottoGeoJsons = { type: 'FeatureCollection', features: [] }
        chocottoGeoJsons.features.push(multiPolygonGeoJson)
        googlemap.$mapPromise.then(map => {
          map.data.addGeoJson(chocottoGeoJsons)
          map.data.setStyle(feature => {
            const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)
            if (type === Constants.GeoFeaturePropertiesType.FIELD) {
              return {
                fillColor: fillColor,
                fillOpacity: fillOpacity,
                strokeColor: Constants.FIELD_FILL_COLOR,
                strokeWeight: 1,
                zIndex: 0,
              }
            } else {
              const color = feature.getProperty('color')
              return {
                fillColor: color,
                fillOpacity: Constants.NOW_TRACK_OPACITY,
                strokeWeight: 0,
                strokeOpacity: 0,
                zIndex: 1,
              }
            }
          })
        })
      }
    },
  },
}
